import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthStatusCard from './AuthStatusCard';
import { useAuth } from './AuthProvider';
import { buildLoginPath } from '../helpers/AuthRedirect';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { status, error, refreshAuth, logout } = useAuth();
  const location = useLocation();

  if (status === 'initializing') {
    return (
      <AuthStatusCard
        title="Checking access"
        message="Verifying your Elite Core administrator session for Command Centre."
      />
    );
  }

  if (status === 'forbidden') {
    return (
      <AuthStatusCard
        title="Administrator Access Required"
        message={
          error ||
          'Command Centre is only available to Elite Core users with the administrator or admin role.'
        }
        actionLabel="Return to login"
        onAction={logout}
      />
    );
  }

  if (status === 'error') {
    return (
      <AuthStatusCard
        title="Connection problem"
        message={
          error ||
          'Command Centre could not verify your session with the Elite Core server.'
        }
        actionLabel="Try again"
        onAction={refreshAuth}
      />
    );
  }

  if (status !== 'authenticated') {
    return <Navigate to={buildLoginPath(undefined, location.search)} replace />;
  }

  return children;
};

export default ProtectedRoute;
